import React from 'react'
import axios from "axios"
import AdminOrders from "./AdminOrders"
import Loader from "../../Components/utils/Loader"

function AdminDashboard() {

    const [generalInfo, setGeneralInfo] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/settings/admin/dashboard/general`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` }
        })
            .then(res => {
                if (res.data.success)
                    setGeneralInfo(res.data?.generalInfo);
            }).finally(() => setIsLoading(false))
    }, [])

    if(isLoading) return <Loader type="simpleMax" />

    return (
        <div className='adminDashboardDiv'>
            <div className="adminDashboardContent">

                <div className="dashboardOverview">

                    <div className="left">

                        <div className="overviewBoxA overviewBox">
                            <h2 className="secondaryHeading">Total Orders</h2>
                            <div className='value'>{(generalInfo.totalOrders < 10 && "0") + generalInfo.totalOrders}</div>
                            <div className="row">
                                <div>Active</div>
                                <div className='fw600'>{(generalInfo.activeOrders < 10 && "0") + generalInfo.activeOrders}</div>
                            </div>
                            <div className="row">
                                <div>Completed</div>
                                <div className='fw600'>{(generalInfo.completedOrders < 10 && "0") + generalInfo.completedOrders}</div>
                            </div>
                        </div>

                        <div className="leftBottom">
                            <div className="overviewBoxB overviewBox">
                                <h2 className="secondaryHeading">Cancelled Orders</h2>
                                <div className="value">{(generalInfo.cancelledOrders < 10 && "0") + generalInfo.cancelledOrders}</div>
                            </div>
                            <div className="overviewBoxB overviewBox">
                                <h2 className="secondaryHeading">Active Products</h2>
                                <div className="value">{(generalInfo.activeProducts < 10 && "0") + generalInfo.activeProducts}</div>
                            </div>
                        </div>

                    </div>

                    <div className="right">

                        <div className="rightTop">
                            <div className="overviewBoxB overviewBox">
                                <h2 className="secondaryHeading">Total Revenue</h2>
                                <div className="value">{(generalInfo.totalRevenue < 10 && "0") + generalInfo.totalRevenue}</div>
                            </div>
                            <div className="overviewBoxB overviewBox">
                                <h2 className="secondaryHeading">Net Profit</h2>
                                <div className="value">{(generalInfo.netProfit < 10 && "0") + generalInfo.netProfit}</div>
                            </div>
                        </div>
                        <div className="overviewBoxA overviewBox">
                            <h2 className="secondaryHeading">Registered Users</h2>
                            <div className='value'>{(generalInfo.registeredUsers < 10 && "0") + generalInfo.registeredUsers}</div>
                            <div className="row">
                                <div>Total Sellers</div>
                                <div className='fw600'>{(generalInfo.totalSellers < 10 && "0") + generalInfo.totalSellers}</div>
                            </div>
                            <div className="row">
                                <div>Paid Sellers</div>
                                <div className='fw600'>{(generalInfo.paidSellers < 10 && "0") + generalInfo.paidSellers}</div>
                            </div>
                        </div>

                    </div>

                </div>

                <AdminOrders pre="dashboard" />

            </div>
        </div>
    )
}

export default AdminDashboard